<template>
  <div :class="{ 'sr-only': !show, 'py-16': !isJustTextRow }" lang="sv">
    <div aria-live="polite" aria-atomic="true">
      <p class="sr-only">{{ notificationStore.title || '' }}</p>
      <p class="sr-only">{{ notificationStore.msg || '' }}</p>
    </div>

    <div v-if="isJustTextRow">
      <div class="flex gap-8 mt-16">
        <nuxt-icon
          filled
          :name="icon"
          class="text-[2.4rem] mt-2"
          aria-hidden="true"
        />
        <div
          class="w-4 self-stretch rounded-full"
          :class="justTextBarColor"
          aria-hidden="true"
        />
        <p class="heading-xxs" :class="justTextTextColor">
          {{ notificationStore.msg }}
        </p>
      </div>
    </div>

    <AppNotification
      v-else
      v-model="showNotification"
      :border-color="borderColor"
      :is-closeable="notificationStore.isCloseable"
      @update:model-value="notificationStore.reset"
    >
      <template #header>
        <nuxt-icon
          filled
          :name="icon"
          class="text-[2.4rem]"
          aria-hidden="true"
        />
        <p class="heading-xxs">
          {{ notificationStore.title }}
        </p>
      </template>
      <div class="flex flex-col gap-8">
        <p>
          {{ notificationStore.msg }}
        </p>
        <NuxtLink
          v-if="notificationStore.link.url"
          :to="notificationStore.link.url"
          external
        >
          <p class="body-link-md text-text-link hover:text-text-link-hover">
            {{ notificationStore.link.text }}
          </p>
        </NuxtLink>
      </div>
    </AppNotification>
  </div>
</template>

<script lang="ts" setup>
const notificationStore = useNotificationStore();

interface Props {
  show: boolean;
  isJustTextRow?: boolean;
}
withDefaults(defineProps<Props>(), {
  isJustTextRow: false,
});

const showNotification = ref(true);

const icon = computed(() => {
  if (notificationStore.type === 'success') {
    return 'check-circle-green';
  }
  if (notificationStore.type === 'warning') {
    return 'alert-circle-orange';
  }
  if (notificationStore.type === 'error') {
    return 'alert-circle-red';
  }
  if (notificationStore.type === 'info') {
    return 'alert-circle-blue';
  }
  return 'alert-circle-blue';
});

const borderColor = computed(() => {
  if (notificationStore.type === 'success') {
    return 'border-border-success';
  }
  if (notificationStore.type === 'warning') {
    return 'border-border-warning';
  }
  if (notificationStore.type === 'error') {
    return 'border-border-error';
  }
  if (notificationStore.type === 'info') {
    return 'border-border-information';
  }
  return 'border-border-information';
});

const justTextBarColor = computed(() => {
  if (notificationStore.type === 'success') {
    return 'bg-border-success';
  }
  if (notificationStore.type === 'warning') {
    return 'bg-border-warning';
  }
  if (notificationStore.type === 'error') {
    return 'bg-border-error';
  }
  if (notificationStore.type === 'info') {
    return 'bg-border-information';
  }
  return 'bg-border-information';
});

const justTextTextColor = computed(() => {
  if (notificationStore.type === 'success') {
    return 'text-text-success';
  }
  if (notificationStore.type === 'warning') {
    return 'text-text-secondary';
  }
  if (notificationStore.type === 'error') {
    return 'text-text-error';
  }
  if (notificationStore.type === 'info') {
    return 'text-text-secondary';
  }
  return 'text-text-error';
});
</script>

<style scoped></style>
